import {Fab} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

export interface CapAddButtonProps {
  onClick?: () => void;
}

export const CapAddButton = (props: CapAddButtonProps) => {
  return (
    <Fab color="primary" aria-label="add" onClick={props.onClick}>
      <AddIcon />
    </Fab>
  )
}